/* unplugin-vue-components disabled */import script from "./LeHealthList.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeHealthList.vue?vue&type=script&lang=ts&setup=true"

import "./LeHealthList.vue?vue&type=style&index=0&id=cfeba1e4&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfeba1e4"]])

export default __exports__